import { render, staticRenderFns } from "./BoxPhotoExample.vue?vue&type=template&id=eb2ad838&scoped=true"
import script from "./BoxPhotoExample.vue?vue&type=script&lang=js"
export * from "./BoxPhotoExample.vue?vue&type=script&lang=js"
import style0 from "./BoxPhotoExample.vue?vue&type=style&index=0&id=eb2ad838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2ad838",
  null
  
)

export default component.exports